<template>
    <div class="col-12 row ps-1 tabFilter" :style="styleFilter">
        <slot name="body"></slot>
    </div>
</template>
<script>
export default {
    name: 'Filters',
    props: {
        styleFilter: {
            String,
            default: ''
        }
    },
    data() {
        return {
            // showFilteres: false
        };
    },

}
</script>

<style lang="scss">
.tabFilter {
    position: absolute;
    z-index: 1000;
    // background: #f9f9f9;
    padding: 10px 5px 10px 5px;
    width: 100vw !important;
    right: 12px;
    border-radius: 5px;
    // box-shadow: 4px 0px 10px 0 #00000040;

}
</style>